import React, { useState } from 'react';
import './ShareButton.css';

function ShareButton({ type, data, customText }) {
  const [showCopied, setShowCopied] = useState(false);

  // 날짜 포맷 함수 (요일 포함)
  const formatDate = (dateString) => {
    if (!dateString) {
      const today = new Date();
      dateString = today.toISOString().split('T')[0];
    }

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const weekday = weekdays[date.getDay()];

    return `${year}년 ${month}월 ${day}일 (${weekday})`;
  };

  // 공유 텍스트 생성
  const generateShareText = () => {
    if (customText) {
      return customText;
    }

    switch (type) {
      case 'lotto':
        return `🎰 로또운세 추천번호
${formatDate()}

${data.numbers.join(', ')}

행운을 빌어요! 🍀

더 보기: https://lottounse.kr/lotto`;

      case 'zodiac':
        return `🔮 오늘의 운세
${formatDate(data.date)}
${data.title}

✨ 총운
${data.overall || ''}
${data.love ? `
💕 애정운
${data.love}` : ''}${data.money ? `
💰 금전운
${data.money}` : ''}${data.health ? `
🏥 건강운
${data.health}` : ''}

🍀 행운 정보
${data.luckyNumbers?.length > 0 ? `숫자: ${data.luckyNumbers.join(', ')}` : ''}${data.luckyColor ? `
색깔: ${data.luckyColor}` : ''}${data.luckyDirection ? `
방향: ${data.luckyDirection}` : ''}

더 보기: https://lottounse.kr/fortune/zodiac`;

      case 'chinese':
        return `🐭 오늘의 운세
${formatDate(data.date)}
${data.title}${data.years ? ` (${data.years})` : ''}

✨ 총운
${data.overall || ''}
${data.love ? `
💕 애정운
${data.love}` : ''}${data.money ? `
💰 금전운
${data.money}` : ''}${data.health ? `
🏥 건강운
${data.health}` : ''}

🍀 행운 정보
${data.luckyNumbers?.length > 0 ? `숫자: ${data.luckyNumbers.join(', ')}` : ''}${data.luckyColor ? `
색깔: ${data.luckyColor}` : ''}${data.luckyDirection ? `
방향: ${data.luckyDirection}` : ''}

더 보기: https://lottounse.kr/fortune/chinese`;

      case 'tarot':
        return `🃏 오늘의 타로
${formatDate(data.date)}
${data.title}

${data.content || data.overall || ''}

더 보기: https://lottounse.kr/fortune/tarot`;

      case 'lucky':
        return `🍀 오늘의 행운
${formatDate(data.date)}

${data.luckyNumbers?.length > 0 ? `숫자: ${data.luckyNumbers.join(', ')}` : ''}${data.luckyColor ? `
색깔: ${data.luckyColor}` : ''}${data.luckyDirection ? `
방향: ${data.luckyDirection}` : ''}

더 보기: https://lottounse.kr/fortune/lucky`;

      default:
        return '로또운세 - 로또 번호 추천 + 오늘의 운세\nhttps://lottounse.kr';
    }
  };

  // Web Share API 사용
  const handleShare = async () => {
    const text = generateShareText();

    // Web Share API 지원 확인
    if (navigator.share) {
      try {
        await navigator.share({
          title: '로또운세',
          text: text,
        });
      } catch (error) {
        // 사용자가 공유 취소한 경우는 무시
        if (error.name !== 'AbortError') {
          console.error('Share failed:', error);
          // 공유 실패 시 복사로 대체
          handleCopy();
        }
      }
    } else {
      // Web Share API 미지원 시 복사
      handleCopy();
    }
  };

  // 클립보드 복사
  const handleCopy = async () => {
    const text = generateShareText();

    try {
      await navigator.clipboard.writeText(text);
      setShowCopied(true);
      setTimeout(() => setShowCopied(false), 2000);
    } catch (error) {
      console.error('Copy failed:', error);
      // 대체 복사 방법
      fallbackCopy(text);
    }
  };

  // 대체 복사 방법 (구형 브라우저)
  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      setShowCopied(true);
      setTimeout(() => setShowCopied(false), 2000);
    } catch (error) {
      console.error('Fallback copy failed:', error);
      alert('복사에 실패했습니다.');
    }

    document.body.removeChild(textarea);
  };

  return (
    <div className="share-button-container">
      <button className="share-button primary" onClick={handleShare}>
        💬 공유하기
      </button>

      <button className="share-button copy" onClick={handleCopy}>
        📋 복사
      </button>

      {showCopied && (
        <div className="copied-toast">
          ✓ 복사되었습니다!
        </div>
      )}
    </div>
  );
}

export default ShareButton;
